const e = [
  {
    color: "#67e9e1",
    value: "1 dot = 100 people",
    ranges: [0, 1 / 0],
    visible: !0
  }
], o = [
  {
    color: "#67e9e1",
    value: "1 dot = 250 people",
    ranges: [0, 1 / 0],
    visible: !0
  }
], _ = [
  {
    color: "#67e9e1",
    value: "1 dot = 500 people",
    ranges: [0, 1 / 0],
    visible: !0
  }
];
export {
  e as POP_DOT_DENSITY_STATIC_CBG_BINS,
  _ as POP_DOT_DENSITY_STATIC_COUNTY_BINS,
  o as POP_DOT_DENSITY_STATIC_ZIPCODE_BINS
};
//# sourceMappingURL=index.es475.js.map
